var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TableOrder"},[_c('div',[_c('phoneTable',{ref:"phonetablechild",attrs:{"partition":_vm.partition,"iid":_vm.iiid}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }